import { PRODUCTION_WIDGET_RUNTIME_ENDPOINTS } from "../production-runtime-endpoints.js";
export { PRODUCTION_WIDGET_RUNTIME_ENDPOINTS };
export const TELEMETRY_EVENTS = {
    INSTANCE_READY: "instance_ready",
    VIEW_DISPLAYED: "view_displayed",
    VIEW_CLOSED: "view_closed",
    FLOW_DISPLAYED: "flow_displayed",
    FLOW_CLOSED: "flow_closed",
};
// Data attribute used to anchor widget styles & root element. Shared so build
// scripts, runtime code and tests stay in sync.
export const WIDGET_SELECTOR = "[data-gx-widget]";
export const PARENT_ORIGIN_PARAM = "gx_parent_origin";
export const PRODUCTION_WIDGET_CORE_URL = PRODUCTION_WIDGET_RUNTIME_ENDPOINTS.coreUrl;
/** @internal Version for the trusted host-realm open-url action event. */
export const OPEN_URL_ACTION_VERSION = 2;
/** @internal Init capability proving that this SDK instance handles open-url actions. */
export const OPEN_URL_ACTION_CAPABILITY = "gx.action.open-url.v2";
/** @internal Rollout capability used with the version 1 `_blank` host event. */
export const OPEN_URL_ACTION_V1_CAPABILITY = "gx.action.open-url.v1";
/**
 * @internal Capability for synchronous navigation outcome settlement by the
 * internal SDK adapter. The browser host remains client-reported and does not
 * provide trusted execution attestation.
 */
export const NAVIGATION_OUTCOME_SETTLEMENT_CAPABILITY = "gx.navigation.outcome-settlement.v1";
// Host event names (DOM events emitted by widget for external consumption)
// Uses prefix "getuserfeedback:" for namespacing
export const HOST_EVENT_PREFIX = "getuserfeedback:";
export const HOST_EVENT_KEYS = {
    INSTANCE_FLOW_LAYOUT_UPDATED: "instance:flow:layout-updated",
    INSTANCE_FLOW_STATE_CHANGED: "instance:flow:state-changed",
    INSTANCE_FLOW_STATE_CHANGED_INSTANCE: "instance:flow:state-changed:instance",
    INSTANCE_VIEW_HOST_SNAPSHOTS_CHANGED: "instance:view-host:snapshots-changed",
    INSTANCE_COMMAND_SETTLED: "instance:command:settled",
    INSTANCE_HANDLE_INVALIDATED: "instance:handle:invalidated",
    INSTANCE_OPEN_REQUESTED: "instance:open:requested",
    INSTANCE_NAVIGATION_REQUESTED: "instance:navigation:requested",
    INSTANCE_HOST_ACTION_REQUESTED: "instance:host-action:requested",
    INSTANCE_COMMAND_UNSUPPORTED: "instance:command:unsupported",
    INSTANCE_READY: "instance:ready",
    INSTANCE_BRIDGE_MOUNTED: "instance:bridge:mounted",
    INSTANCE_BRIDGE_UNMOUNTED: "instance:bridge:unmounted",
    INSTANCE_IFRAME_READY: "instance:iframe:ready",
    INSTANCE_ERROR: "instance:error",
    INSTANCE_APP_EVENT: "instance:app-event",
};
const SDK_COMMAND_CAPABILITY_BY_KIND = {
    configure: "gx.command.configure.v1",
    open: "gx.command.open.v1",
    prefetch: "gx.command.prefetch.v1",
    prerender: "gx.command.prerender.v1",
    identify: "gx.command.identify.v1",
    setContainer: "gx.command.setContainer.v1",
    close: "gx.command.close.v1",
    reset: "gx.command.reset.v1",
    setDefaultContainerPolicy: "gx.command.setDefaultContainerPolicy.v1",
    track: "gx.command.track.v1",
};
const SDK_COMMAND_CAPABILITIES = [
    SDK_COMMAND_CAPABILITY_BY_KIND.configure,
    SDK_COMMAND_CAPABILITY_BY_KIND.open,
    SDK_COMMAND_CAPABILITY_BY_KIND.prefetch,
    SDK_COMMAND_CAPABILITY_BY_KIND.prerender,
    SDK_COMMAND_CAPABILITY_BY_KIND.identify,
    SDK_COMMAND_CAPABILITY_BY_KIND.setContainer,
    SDK_COMMAND_CAPABILITY_BY_KIND.close,
    SDK_COMMAND_CAPABILITY_BY_KIND.reset,
    SDK_COMMAND_CAPABILITY_BY_KIND.setDefaultContainerPolicy,
    SDK_COMMAND_CAPABILITY_BY_KIND.track,
];
/**
 * Stable capability tokens announced by the browser SDK during init.
 * These are versioned and namespaced to support forward-compatible negotiation.
 */
export const FLOW_LAYOUT_UPDATES_CAPABILITY = "gx.host.flow-layout-updates.v1";
export const SDK_PROTOCOL_CAPABILITIES = [
    "gx.protocol.public.v1",
    ...SDK_COMMAND_CAPABILITIES,
    NAVIGATION_OUTCOME_SETTLEMENT_CAPABILITY,
];
export const REACT_NATIVE_WEBVIEW_TRANSPORT_CAPABILITIES = {
    LAYOUT_TRANSITION_POLICY: "gx.react-native.webview.layout-transition-policy.v1",
    LAYOUT_TRANSITION_SCHEDULE: "gx.react-native.webview.layout-transition-schedule.v1",
};
export const LOADER_RUNTIME_GLOBAL_KEY = "__getuserfeedback_runtime";
export const LOADER_RUNTIME_PROTOCOL_VERSION = "v5";
// Helper to construct full event name with prefix
export const toHostEventName = (key) => `${HOST_EVENT_PREFIX}${key}`;
